import { NAVIGATION_DESIGN_TYPE, NAVIGATION_POSITION_TYPE, NAVIGATION_SIZE_TYPE, NAVIGATION_THEME_TYPE, NAVIGATION_TYPE } from "./Gallery"

/* Protopia Ecosystem component */
export interface IPrevButtonProps {
    onClick: () => void
    navigationType:NAVIGATION_TYPE
    navigationThemeType: NAVIGATION_THEME_TYPE
    navigationPositionType?: NAVIGATION_POSITION_TYPE
    navigationSizeType?:NAVIGATION_SIZE_TYPE
    navigationDesignType?: NAVIGATION_DESIGN_TYPE
}
const PrevButton = (props: IPrevButtonProps): JSX.Element => {
    const navigationPositionType = props.navigationPositionType
    const navigationType = props.navigationType
    const navigationThemeType = props.navigationThemeType
    const navigationSizeType = props.navigationSizeType
    const navigationDesignType = props.navigationDesignType
    
    let className: string = `pe-prev-button-${ navigationPositionType || "" }${navigationType}-${ navigationThemeType }-${ navigationSizeType }-container`
    return <div className={className} onClick={props.onClick}>
        <i className={`fas fa-${ navigationDesignType || NAVIGATION_DESIGN_TYPE.CHEVRON }-left`} />
    </div> 
}
export default PrevButton
 